import type { GetStylesClassNameOptions } from './types'

export const getStylesClassName = (
  styles: Record<string, string>,
  options: GetStylesClassNameOptions
): string | undefined => {
  const { block, element: rawElement, modificator: rawModificator } = options

  const element: string = rawElement ? `__${rawElement}` : ''
  const modificator: string = rawModificator ? `_${rawModificator}` : ''

  return styles[`${block}${element}${modificator}`]
}
